import { Component } from '@theme/component';
class FormwinkFinder extends Component {
  recommend(event) {
    event.preventDefault();
    const data = new FormData(event.target);
    const space = data.get('space');
    const budget = data.get('budget');
    const key = budget === 'room' ? 'room' : budget === 'light' ? 'light' : (space === 'table' || space === 'gift') ? 'holder' : 'clock';
    const url = this.dataset[`${key}Url`];
    if (!url) return;
    this.refs.resultLink.href = url;
    this.refs.resultLink.textContent = this.dataset[`${key}Title`];
    this.refs.result.hidden = false;
    this.refs.resultLink.focus();
  }
  reset() {
    this.refs.result.hidden = true;
    this.querySelector('select')?.focus();
  }
}
if (!customElements.get('formwink-finder')) customElements.define('formwink-finder', FormwinkFinder);
